<template>
  <div class="List" :class="classStyle">
    <div class="title">
      {{title}}
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    classStyle: {
      typpe: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/reset.scss";
.Footer{
  text-align: center;
  width: 1440px;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue